import type { TireEfficiencyFlagProps } from '@packages/shared/src/ui/TireEfficiencyFlag/TireEfficiencyFlag';
import type { TireEfficiencyFlagFragmentFragment } from '@packages/gql/generated/shopping/graphql';

export const getTireEfficiencyFlagType = (
  type: TireEfficiencyFlagFragmentFragment['type'],
): TireEfficiencyFlagProps['type'] | null => {
  switch (type) {
    case 'WETGRIP': {
      return 'wetGrip';
    }
    case 'FUELEFFICIENCY': {
      return 'fuelEfficiency';
    }
    case 'EXTERNALROLLINGNOISE': {
      return 'externalRollingNoise';
    }
    default: {
      return null;
    }
  }
};
